import {RemoteCollectionStore, StoreBuilder} from '@softline/core';
import {InventurArtikelDetail} from '../data/inventur-artikel-detail';

export const InventurArtikelDetailStore =
  new StoreBuilder(RemoteCollectionStore.create<InventurArtikelDetail>())
    .value
